"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _polished = require("polished");
var _styled = require("../../styled");
var _baseTheme = require("./baseTheme");
var _templateObject;
var lineHeight = function lineHeight(height, base) {
  if (base === void 0) {
    base = _baseTheme.basePixelSize;
  }
  var lh = (parseFloat(height) / parseFloat(base)).toFixed(6);
  return "" + parseFloat(lh);
};
var GlobalStyles = (0, _styled.createGlobalStyle)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n\n  body {\n    padding: 0;\n    margin: 0;\n    font-family: \"Work Sans\", Arial, sans-serif;\n  }\n"])));

// COLORS
var colors = {
  black: '#000',
  white: '#fff',
  grey: '#E2DCD6',
  lightGrey: '#AFAFAF',
  lightGreyBorder: '#A49F9E',
  mediumGrey: '#E9E5E4',
  darkGrey: '#4a4a4a',
  fbBlue: '#37559C',
  green: '#57CBA1',
  red: '#FA6060',
  lightYellow: '#FEFFCC',
  lightRed: '#FFE4E4',
  lightRedBorder: '#C79898'
};
var contextualColors = {
  primary: colors.darkGrey,
  secondary: colors.black,
  backgroundPrimary: colors.mediumGrey,
  backgroundSecondary: colors.white,
  backgroundDark: colors.darkGrey,
  backgroundBox: (0, _polished.transparentize)(1, colors.white),
  invalid: colors.lightRed,
  invalidBorder: colors.lightRedBorder,
  valid: colors.lightYellow,
  inputBorder: colors.lightGreyBorder,
  error: colors.red,
  wishlistIcon: colors.black,
  overlayClose: colors.black,
  overlayText: colors.black,
  overlayButton: colors.black,
  lightboxBackground: colors.white,
  lightboxBackdrop: (0, _polished.transparentize)(0.15, colors.black),
  lightboxLoader: colors.white,
  borderPrimary: colors.lightGreyBorder,
  alert: colors.lightRedBorder,
  active: colors.black,
  success: colors.green
};
var baseTypography = {
  fontFamily: '"Work Sans", Arial, sans-serif',
  inputFontFamily: '"Work Sans", Arial, sans-serif',
  lineHeight: 1.5,
  marginBottom: '1.5rem',
  letterSpacing: (0, _polished.rem)(-0.6)
};
var typography = {
  pageTitle: {
    fontFamily: baseTypography.fontFamily,
    fontSize: (0, _polished.rem)(24),
    fontSizeLarge: (0, _polished.rem)(48),
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: baseTypography.lineHeight,
    marginBottom: baseTypography.marginBottom,
    textTransform: 'none',
    letterSpacing: (0, _polished.rem)(-1.5)
  },
  headline: {
    fontFamily: baseTypography.fontFamily,
    fontSize: (0, _polished.rem)(18),
    fontSizeLarge: (0, _polished.rem)(26),
    fontStyle: 'normal',
    lineHeight: baseTypography.lineHeight,
    marginBottom: baseTypography.marginBottom,
    textTransform: 'none'
  },
  subHeadline: {
    fontFamily: baseTypography.fontFamily,
    fontSize: (0, _polished.rem)(16),
    fontSizeLarge: (0, _polished.rem)(16),
    fontStyle: 'normal',
    lineHeight: baseTypography.lineHeight,
    marginBottom: '0.5rem',
    textTransform: 'none'
  },
  paragraph: {
    fontFamily: baseTypography.fontFamily,
    fontSize: (0, _polished.rem)(14),
    fontSizeLarge: (0, _polished.rem)(14),
    fontStyle: 'normal',
    lineHeight: baseTypography.lineHeight,
    marginBottom: baseTypography.marginBottom,
    fontWeight: '400'
  },
  pageDescription: {
    fontFamily: baseTypography.fontFamily,
    fontSize: (0, _polished.rem)(16),
    fontSizeLarge: (0, _polished.rem)(18),
    fontStyle: 'normal',
    lineHeight: baseTypography.lineHeight,
    marginBottom: baseTypography.marginBottom
  },
  helpText: {
    fontFamily: baseTypography.fontFamily,
    fontSize: (0, _polished.rem)(20),
    fontSizeLarge: (0, _polished.rem)(24),
    fontStyle: 'normal',
    lineHeight: baseTypography.lineHeight,
    marginBottom: baseTypography.marginBottom
  },
  statusText: {
    fontFamily: baseTypography.fontFamily,
    fontSize: (0, _polished.rem)(16),
    fontSizeLarge: (0, _polished.rem)(16),
    fontStyle: 'normal',
    lineHeight: baseTypography.lineHeight,
    marginBottom: baseTypography.marginBottom,
    marginTop: '0.5rem'
  },
  input: {
    fontFamily: baseTypography.inputFontFamily,
    fontSize: (0, _polished.rem)(14),
    fontSizeLarge: (0, _polished.rem)(14),
    fontStyle: 'normal',
    lineHeight: 1,
    marginBottom: (0, _polished.rem)(28)
  },
  label: {
    fontFamily: baseTypography.inputFontFamily,
    fontSize: (0, _polished.rem)(14),
    fontSizeLarge: (0, _polished.rem)(14),
    fontStyle: 'normal',
    explanationFontSize: (0, _polished.rem)(12),
    lineHeight: 1,
    marginBottom: (0, _polished.rem)(8)
  },
  error: {
    fontFamily: baseTypography.inputFontFamily,
    fontSize: (0, _polished.rem)(13),
    fontSizeLarge: (0, _polished.rem)(13),
    fontStyle: 'normal',
    lineHeight: 1
  },
  link: {
    color: contextualColors.primary
  }
};
var forms = {
  borderRadius: (0, _polished.rem)(2),
  height: (0, _polished.rem)(42),
  padding: (0, _polished.rem)(12),
  fontFamily: baseTypography.fontFamily,
  fontWeight: 400,
  fontSize: (0, _polished.rem)(14),
  lineHeight: 1,
  fontSizeDesktop: (0, _polished.rem)(14),
  lineHeightDesktop: 1,
  marginBottom: (0, _polished.rem)(28),
  errorMessage: {
    borderRadius: (0, _polished.rem)(2)
  },
  addressResults: {
    height: (0, _polished.rem)(242),
    borderRadius: (0, _polished.rem)(2),
    padding: (0, _polished.rem)(2) + " " + (0, _polished.rem)(8)
  },
  colors: {
    color: contextualColors.primary,
    // colors.primary
    background: colors.white,
    // colors.white
    border: contextualColors.borderPrimary,
    // colors.inputbBorder
    valid: contextualColors.valid,
    // colors.valid
    validBackground: contextualColors.valid,
    // colors.valid
    errorColor: colors.white,
    // colors.invalidBorder
    errorBackground: contextualColors.invalidBorder,
    // colors.invalidBorder
    invalidBorder: contextualColors.invalidBorder,
    //  contextualColors.alert, // colors.invalidBorder
    invalidBackground: contextualColors.invalid,
    // contextualColors.error, // colors.invalid
    activeBorder: contextualColors.active,
    // colors.black
    active: contextualColors.active,
    invalid: colors.red,
    // colors.invalidBorder
    selected: contextualColors.success,
    checkboxBackground: colors.white // colors.black
  },
  label: {
    fontFamily: baseTypography.fontFamily,
    fontWeight: 400,
    fontSize: (0, _polished.rem)(14),
    explanationFontSize: (0, _polished.rem)(12),
    lineHeight: 1,
    fontSizeDesktop: (0, _polished.rem)(14),
    lineHeightDesktop: 1,
    marginBottom: (0, _polished.rem)(8)
  }
};
var button = {
  borderRadius: 0,
  borderWidth: '1px',
  borderLeftPosition: '0',
  borderRightPosition: '0',
  fontFamily: baseTypography.fontFamily,
  fontSize: (0, _polished.rem)(14),
  fontWeight: '300',
  textTransform: 'none',
  colors: {
    primaryColor: colors.white,
    primaryBackground: colors.black,
    secondaryColor: colors.lightGrey,
    secondaryBackground: colors.darkGrey,
    successColor: colors.white,
    successBackground: colors.green
  },
  margin: (0, _styled.switchProp)('size', {
    small: "0 " + (0, _polished.rem)(5) + " " + (0, _polished.rem)(5) + " 0",
    normal: "0 " + (0, _polished.rem)(15) + " " + (0, _polished.rem)(15) + " 0",
    large: "0 " + (0, _polished.rem)(10) + " " + (0, _polished.rem)(10) + " 0"
  }),
  padding: (0, _styled.switchProp)('size', {
    small: (0, _polished.rem)(10) + " " + (0, _polished.rem)(40),
    normal: (0, _polished.rem)(15) + " " + (0, _polished.rem)(45),
    large: (0, _polished.rem)(20) + " " + (0, _polished.rem)(50)
  }),
  siblingMargin: 0
};
var zIndex = {
  overlay: 1000
};
var icons = {
  padding: 0,
  textMargin: (0, _polished.rem)(8),
  colors: {
    primaryColor: contextualColors.primary,
    secondaryColor: colors.white
  }
};
var overlay = {
  container: {
    zIndex: zIndex.overlay,
    background: contextualColors.backgroundSecondary
  },
  header: {
    height: (0, _polished.rem)(72),
    color: colors.white,
    background: contextualColors.backgroundDark
  },
  lightbox: {
    zIndex: zIndex.overlay,
    backdrop: contextualColors.lightboxBackdrop,
    loader: contextualColors.lightboxLoader,
    closeButton: {
      color: colors.white,
      background: 'none',
      hoverBackground: 'none'
    }
  },
  closeButton: {
    color: colors.white
  }
};
var grid = {
  columns: 12,
  gutter: '20px',
  // hedron default
  container: '960px' // hedron default
};
var breakpoints = {
  xxs: 0,
  xs: 540,
  sm: 720,
  md: 960,
  lg: 1140,
  xl: 1920,
  xxl: 2560
};
var tooltip = {
  colors: {
    primaryColor: contextualColors.primary,
    primaryBackground: contextualColors.backgroundPrimary
  }
};
var keyboard = {
  colors: {
    key: colors.black,
    shadow: colors.grey
  }
};
var uploads = {
  galleryThumbnail: {
    background: colors.grey,
    button: {
      background: contextualColors.primary,
      color: contextualColors.backgroundPrimary
    },
    progressBar: {
      background: (0, _polished.transparentize)(0.2, colors.black),
      color: colors.white
    }
  },
  errorMessage: {
    color: colors.white,
    background: contextualColors.invalidBorder,
    border: contextualColors.invalidBorder
  }
};
var tabs = {
  border: "1px solid " + colors.grey,
  color: {
    default: colors.grey,
    active: colors.black,
    activeMarker: colors.black
  },
  fontWeight: 'normal',
  fontSize: '1rem',
  textTransform: 'uppercase',
  padding: grid.gutter,
  paddingDesktop: grid.gutter,
  textAlign: 'left',
  activeFontWeight: 'normal'
};

// THEME DEFINITION
var baseTheme = {
  GlobalStyles: GlobalStyles,
  breakpoints: breakpoints,
  grid: grid,
  zIndex: zIndex,
  zOverlay: zIndex.overlay,
  // TODO: remove/deprecate
  rem: function rem(size) {
    return (0, _polished.rem)(size, _baseTheme.basePixelSize);
  },
  lineHeight: lineHeight,
  button: button,
  typography: typography,
  forms: forms,
  icons: icons,
  overlay: overlay,
  tooltip: tooltip,
  keyboard: keyboard,
  uploads: uploads,
  tabs: tabs,
  colors: Object.assign({}, colors, contextualColors)
};
var _default = exports.default = baseTheme;